<template>
  <div class="membresias-page">
    <div class="bg-grid" aria-hidden="true"></div>

    <div class="membresias-shell">
      <!-- Stats -->
      <section class="dash-section fade-in delay-100">
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-top">
              <div class="stat-icon">
                <v-icon size="18" color="#F2F2ED">mdi-format-list-bulleted</v-icon>
              </div>
            </div>
            <div class="stat-value">{{ membresias.length }}</div>
            <div class="stat-label">Planes disponibles</div>
          </div>

          <div class="stat-card">
            <div class="stat-top">
              <div class="stat-icon stat-icon-accent">
                <v-icon size="18" color="#0E0E10">mdi-cash-multiple</v-icon>
              </div>
            </div>
            <div class="stat-value">${{ precioPromedio }}</div>
            <div class="stat-label">Precio promedio</div>
          </div>

          <div class="stat-card">
            <div class="stat-top">
              <div class="stat-icon">
                <v-icon size="18" color="#F2F2ED">mdi-timer-sand</v-icon>
              </div>
            </div>
            <div class="stat-value">{{ duracionPromedio }}</div>
            <div class="stat-label">Duración promedio</div>
          </div>
        </div>
      </section>

      <!-- Contenido principal -->
      <section class="dash-section fade-in delay-200">
        <div v-if="cargando" class="loading-state">
          <div class="spinner"></div>
          <p class="loading-text">Cargando membresías…</p>
        </div>

        <div v-else-if="membresias.length === 0" class="empty-state">
          <div class="empty-icon">
            <v-icon size="30" color="#5C5C62">mdi-medal-outline</v-icon>
          </div>
          <h3 class="empty-title">No hay membresías registradas</h3>
          <p class="empty-desc">Comienza creando tu primer plan de membresía</p>
          <button class="btn-primary mt-lg" @click="nuevaMembresia">
            <v-icon size="15" class="mr-2">mdi-plus</v-icon>
            Crear primera membresía
          </button>
        </div>

        <div v-else class="membresias-grid">
          <div v-for="(membresia, index) in membresias" :key="membresia.id" class="membresia-card"
            :style="{ animationDelay: (0.04 * index) + 's' }">
            <div class="membresia-top">
              <div class="membresia-icon" :class="getTipoColor(membresia.nombre)">
                <v-icon size="18" :color="getTipoColor(membresia.nombre) === 'chip-accent' ? '#0E0E10' : '#F2F2ED'">
                  mdi-medal-outline
                </v-icon>
              </div>
              <div class="membresia-actions">
                <button class="icon-btn" @click="editar(membresia)" title="Editar">
                  <v-icon size="15" color="#8C8C93">mdi-pencil</v-icon>
                </button>
                <button class="icon-btn icon-btn-danger" @click="eliminar(membresia)" title="Eliminar">
                  <v-icon size="15" color="#FF6B6B">mdi-delete</v-icon>
                </button>
              </div>
            </div>

            <h3 class="membresia-name">{{ membresia.nombre }}</h3>

            <div class="membresia-price">
              <span class="price-currency">$</span>{{ formatMoney(membresia.precio) }}
            </div>

            <div class="membresia-duration">
              <v-icon size="14" class="mr-2" color="#5C5C62">mdi-calendar-clock</v-icon>
              {{ membresia.duracion }} días
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- FAB -->
    <button class="fab-button" @click="nuevaMembresia">
      <v-icon size="22" color="#0E0E10">mdi-plus</v-icon>
    </button>

    <!-- Dialog: Formulario de Membresía -->
    <v-dialog v-model="mostrarDialogo" persistent max-width="600px">
      <form-membresia @cerrado="onCerrado" @registrar="onRegistrar" :membresia="membresia" :titulo="titulo" />
    </v-dialog>

    <!-- Dialog: Confirmar Eliminación -->
    <v-dialog v-model="mostrarDialogoEliminar" max-width="480px">
      <div class="modal-panel">
        <div class="modal-head">
          <h3 class="modal-title">Confirmar eliminación</h3>
        </div>

        <div class="modal-body">
          <p class="modal-text">
            ¿Estás seguro de eliminar la membresía
            <strong class="text-error">"{{ itemSeleccionado }}"</strong>?
          </p>
          <div class="alert-box">
            <v-icon size="18" color="#FFB84D">mdi-alert</v-icon>
            <div class="alert-text">
              Esta acción no se puede deshacer. Los miembros con esta membresía deberán ser actualizados.
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn-ghost" @click="cerrarDialogoEliminar">Cancelar</button>
          <button class="btn-danger-solid" @click="confirmarEliminar" :disabled="cargando">
            <span v-if="!cargando">Eliminar</span>
            <span v-else class="loading-inline"><span class="spinner-sm"></span>Eliminando</span>
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top right>
      <div class="flex items-center gap-md">
        <v-icon color="white">{{ mensajeIcon }}</v-icon>
        <span>{{ mensaje.texto }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small @click="mostrarMensaje = false" v-bind="attrs">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FormMembresia from './FormMembresia.vue'
import HttpService from '../../Servicios/HttpService'

export default {
  name: "Membresias",
  components: { FormMembresia },

  data: () => ({
    cargando: false,
    mostrarDialogo: false,
    mostrarDialogoEliminar: false,
    membresia: {
      nombre: "",
      duracion: "",
      precio: ""
    },
    membresias: [],
    mensaje: {
      texto: "",
      color: ""
    },
    mostrarMensaje: false,
    titulo: "Agregar",
    itemSeleccionado: ""
  }),

  computed: {
    precioPromedio() {
      if (this.membresias.length === 0) return '0.00'

      try {
        const total = this.membresias.reduce((sum, m) => {
          const precio = parseFloat(m.precio) || 0
          return sum + precio
        }, 0)

        return (total / this.membresias.length).toFixed(2)
      } catch (error) {
        console.error('Error calculando precio promedio:', error)
        return '0.00'
      }
    },

    duracionPromedio() {
      if (this.membresias.length === 0) return '0 días'

      try {
        const diasTotales = this.membresias.reduce((sum, m) => {
          if (!m.duracion || typeof m.duracion !== 'string') {
            return sum + 30
          }

          const duracion = m.duracion.toLowerCase().trim()

          if (duracion.includes('semanal')) return sum + 7
          if (duracion.includes('mensual')) return sum + 30
          if (duracion.includes('semestral')) return sum + 180
          if (duracion.includes('anual')) return sum + 365
          if (duracion.includes('día') || duracion.includes('dia')) {
            const match = duracion.match(/\d+/)
            return match ? sum + parseInt(match[0]) : sum + 1
          }

          const match = duracion.match(/\d+/)
          return match ? sum + parseInt(match[0]) : sum + 30
        }, 0)

        const promedioDias = Math.round(diasTotales / this.membresias.length)

        if (promedioDias >= 365) {
          const años = promedioDias / 365
          return `${años.toFixed(1)} ${años === 1 ? 'año' : 'años'}`
        } else if (promedioDias >= 30) {
          const meses = promedioDias / 30
          return `${meses.toFixed(1)} ${meses === 1 ? 'mes' : 'meses'}`
        } else {
          return `${promedioDias} ${promedioDias === 1 ? 'día' : 'días'}`
        }
      } catch (error) {
        console.error('Error calculando duración promedio:', error)
        return '30 días'
      }
    },

    mensajeIcon() {
      switch (this.mensaje.color) {
        case 'success': return 'mdi-check-circle'
        case 'error': return 'mdi-alert-circle'
        case 'warning': return 'mdi-alert'
        default: return 'mdi-information'
      }
    }
  },

  mounted() {
    this.obtenerMembresias()
  },

  methods: {
    formatMoney(amount) {
      if (!amount) return '0.00';
      return parseFloat(amount).toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    nuevaMembresia() {
      this.titulo = "Agregar"
      this.membresia = {
        nombre: "",
        duracion: "",
        precio: ""
      }
      this.mostrarDialogo = true
    },

    editar(membresia) {
      this.titulo = "Editar"
      this.membresia = {
        id: membresia.id,
        nombre: membresia.nombre || "",
        duracion: membresia.duracion || "",
        precio: membresia.precio || ""
      }
      this.mostrarDialogo = true
    },

    eliminar(membresia) {
      this.itemSeleccionado = membresia.nombre || "Sin nombre"
      this.membresia = {
        id: membresia.id,
        nombre: membresia.nombre || "",
        duracion: membresia.duracion || "",
        precio: membresia.precio || ""
      }
      this.mostrarDialogoEliminar = true
    },

    cerrarDialogoEliminar() {
      this.mostrarDialogoEliminar = false
      this.membresia = {
        nombre: "",
        duracion: "",
        precio: ""
      }
    },

    async confirmarEliminar() {
      this.cargando = true
      let payload = {
        metodo: "delete",
        id: this.membresia.id
      }

      try {
        const eliminado = await HttpService.eliminar("membresias.php", payload)
        if (eliminado) {
          this.mostrarDialogoEliminar = false
          this.mostrarMensaje = true
          this.mensaje = {
            texto: " Membresía eliminada correctamente",
            color: "success"
          }
          await this.obtenerMembresias()
        }
      } catch (error) {
        console.error('Error eliminando membresía:', error)
        this.mostrarMensaje = true
        this.mensaje = {
          texto: " Error al eliminar la membresía",
          color: "error"
        }
      } finally {
        this.cargando = false
      }
    },

    onCerrado(valor) {
      this.membresia = {
        nombre: "",
        duracion: "",
        precio: ""
      }
      this.mostrarDialogo = valor
      this.titulo = "Agregar"
    },

    async onRegistrar(membresia) {
      let metodo = (this.titulo === "Agregar") ? "post" : "put"
      this.membresia = membresia
      this.cargando = true

      if (!this.membresia.nombre || !this.membresia.duracion || !this.membresia.precio) {
        this.mostrarMensaje = true
        this.mensaje = {
          texto: " Todos los campos son obligatorios",
          color: "error"
        }
        this.cargando = false
        return
      }

      let payload = {
        metodo: metodo,
        membresia: this.membresia
      }

      try {
        const respuesta = await HttpService.registrar(payload, "membresias.php")
        if (respuesta) {
          this.membresia = {
            nombre: "",
            duracion: "",
            precio: ""
          }
          this.mostrarDialogo = false
          this.mostrarMensaje = true
          this.mensaje = {
            texto: " Membresía registrada correctamente",
            color: "success"
          }
          await this.obtenerMembresias()
          this.titulo = "Agregar"
        }
      } catch (error) {
        console.error('Error registrando membresía:', error)
        this.mostrarMensaje = true
        this.mensaje = {
          texto: " Error al registrar la membresía",
          color: "error"
        }
      } finally {
        this.cargando = false
      }
    },

    async obtenerMembresias() {
      this.cargando = true
      let payload = { metodo: "get" }

      try {
        const respuesta = await HttpService.obtenerConDatos(payload, "membresias.php")

        this.membresias = respuesta.map(m => ({
          id: m.id || 0,
          nombre: m.nombre || "Sin nombre",
          duracion: m.duracion || "Sin duración",
          precio: m.precio || "0"
        }))
      } catch (error) {
        console.error('Error cargando membresías:', error)
        this.mostrarMensaje = true
        this.mensaje = {
          texto: " Error al cargar las membresías",
          color: "error"
        }
        this.membresias = []
      } finally {
        this.cargando = false
      }
    },

    getTipoColor(nombre) {
      if (!nombre || typeof nombre !== 'string') return 'chip-neutral'
      const tipo = nombre.toLowerCase().trim()
      if (tipo.includes('semestral') || tipo.includes('anual') || tipo.includes('premium')) return 'chip-accent'
      return 'chip-neutral'
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

/* ===== TOKENS ===== */
.membresias-page {
  --bg: #0E0E10;
  --card: #17171A;
  --card-hover: #1B1B1F;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --accent-dim: rgba(200, 255, 77, 0.12);
  --warning: #FFB84D;
  --error: #FF6B6B;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
}

.membresias-page {
  min-height: 100vh;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font-body);
  position: relative;
  padding: 40px;
}

.bg-grid {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(242, 242, 237, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(242, 242, 237, 0.02) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
}

.membresias-shell {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
}

.dash-section {
  margin-bottom: 28px;
}

/* ===== STATS ===== */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
}

.stat-card {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 20px;
  animation: fadeInUp 0.4s ease both;
}

.stat-top {
  margin-bottom: 16px;
}

.stat-icon {
  width: 34px;
  height: 34px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon-accent {
  background: var(--accent);
  border-color: var(--accent);
}

.stat-value {
  font-family: var(--font-display);
  font-size: 26px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 13px;
  color: var(--text-secondary);
}

/* ===== LOADING / EMPTY ===== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 0;
  gap: 16px;
}

.loading-text {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-secondary);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 56px 20px;
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
}

.empty-icon {
  width: 56px;
  height: 56px;
  border-radius: var(--radius);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.empty-title {
  font-family: var(--font-display);
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 6px;
}

.empty-desc {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

/* ===== GRID DE MEMBRESÍAS ===== */
.membresias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
}

.membresia-card {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 20px;
  animation: fadeInUp 0.4s ease both;
  transition: border-color 0.15s ease;
}

.membresia-card:hover {
  border-color: var(--text-tertiary);
}

.membresia-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.membresia-icon {
  width: 34px;
  height: 34px;
  border-radius: var(--radius);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--card-border);
}

.membresia-icon.chip-accent {
  background: var(--accent);
  border-color: var(--accent);
}

.membresia-icon.chip-neutral {
  background: rgba(255, 255, 255, 0.04);
}

.membresia-actions {
  display: flex;
  gap: 4px;
}

.icon-btn {
  width: 28px;
  height: 28px;
  border-radius: var(--radius);
  background: transparent;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.icon-btn:hover {
  border-color: var(--card-border);
  background: rgba(255, 255, 255, 0.03);
}

.icon-btn-danger:hover {
  border-color: rgba(255, 107, 107, 0.3);
  background: rgba(255, 107, 107, 0.06);
}

.membresia-name {
  font-family: var(--font-display);
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 12px;
}

.membresia-price {
  font-family: var(--font-display);
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 10px;
}

.price-currency {
  font-size: 16px;
  color: var(--text-tertiary);
  margin-right: 2px;
  font-weight: 600;
}

.membresia-duration {
  display: flex;
  align-items: center;
  font-size: 12.5px;
  color: var(--text-secondary);
  padding-top: 12px;
  border-top: 1px solid var(--card-border);
}

/* ===== FAB ===== */
.fab-button {
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--accent);
  border: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, filter 0.15s ease;
}

.fab-button:hover {
  transform: scale(1.06);
  filter: brightness(1.05);
}

/* ===== BUTTONS ===== */
.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover {
  filter: brightness(1.08);
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

.btn-danger-solid {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--error);
  color: #ff0000;
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-danger-solid:hover:not(:disabled) {
  filter: brightness(1.1);
}

.btn-danger-solid:disabled {
  opacity: 0.6;
  cursor: default;
}

.loading-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 22px;
  height: 22px;
  border: 2px solid var(--card-border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.spinner-sm {
  width: 11px;
  height: 11px;
  border: 2px solid rgba(0, 0, 0, 0.25);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===== MODAL ===== */
.modal-panel {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
}

.modal-head {
  padding: 22px 24px;
  border-bottom: 1px solid var(--card-border);
}

.modal-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin: 0;
}

.modal-body {
  padding: 24px;
}

.modal-text {
  font-size: 13.5px;
  color: var(--text-secondary);
  margin: 0 0 18px;
  line-height: 1.6;
}

.modal-text strong {
  color: var(--error);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--card-border);
}

.alert-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: rgba(255, 184, 77, 0.08);
  border: 1px solid rgba(255, 184, 77, 0.25);
  border-radius: var(--radius);
  padding: 12px 14px;
}

.alert-text {
  font-size: 12.5px;
  color: var(--text-secondary);
  line-height: 1.5;
}

/* ===== MOTION ===== */
.fade-in {
  animation: fadeIn 0.4s ease both;
}

.delay-100 { animation-delay: 0.05s; }
.delay-200 { animation-delay: 0.1s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in, .stat-card, .membresia-card, .spinner, .spinner-sm { animation: none; }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .membresias-page {
    padding: 20px;
  }

  .membresias-grid {
    grid-template-columns: 1fr;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Membresias/Membresias.vue